import { render, staticRenderFns } from "./QZ03.vue?vue&type=template&id=018afe9a&scoped=true"
import script from "./QZ03.vue?vue&type=script&lang=js"
export * from "./QZ03.vue?vue&type=script&lang=js"
import style0 from "./QZ03.vue?vue&type=style&index=0&id=018afe9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018afe9a",
  null
  
)

export default component.exports